import script from "./legacy-p9-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./legacy-p9-report-table.vue?vue&type=script&setup=true&lang=js"

import "./legacy-p9-report-table.vue?vue&type=style&index=0&id=fde85864&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde85864"]])

export default __exports__